/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { PaginationMetaDto } from './pagination-meta-dto';
import { ProtocolDto } from './protocol-dto';
 /**
 *
 *
 * @export
 * @interface ProtocolPaginatedResponseDto
 */
export interface ProtocolPaginatedResponseDto {

    /**
     * @type {Array<ProtocolDto>}
     * @memberof ProtocolPaginatedResponseDto
     */
    data: Array<ProtocolDto>;

    /**
     * @type {PaginationMetaDto}
     * @memberof ProtocolPaginatedResponseDto
     */
    meta: PaginationMetaDto;
}
